import {doApiGet} from "./Requests";
import {PaginationParameters, toQueryParameters} from "./Pagination";
import { PaginatedData } from "../hooks/PaginationHooks";
import { AnalysisFile, AnalysisFileType } from "../types/analysisFileTypes";
import { CompanyInvoiceFile } from "../types/invoiceTypes";

export const companyBillingsApi = {
  getAnalysisFilesByFileType: (pagination: PaginationParameters, fileType: AnalysisFileType) =>
    doApiGet<PaginatedData<AnalysisFile>>(`/api/companies/current/analysisfiles?${toQueryParameters(pagination)}&fileType=${fileType}`),

  getInvoices: (pagination: PaginationParameters) =>
    doApiGet<PaginatedData<CompanyInvoiceFile>>(`/api/companies/current/invoices?${toQueryParameters(pagination)}`),
}